import React from "react";
import { css } from "styled-components";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";

const enum fields {
    youtubeVideoId = "youtubeVideoId",
    autoplay = "autoplay",
    mute = "mute",
    height = "height"
}

interface Props extends WidgetProps {
    fields: {
        [fields.youtubeVideoId]: string;
        [fields.autoplay]: string;
        [fields.mute]: string;
        [fields.height]: string;
    }
}

const DividerEWidget: React.FC<Props> = ({ fields: { youtubeVideoId, autoplay, mute, height } }) => {
    const wrapperStyles = {
        css: css`
            width: 100%;
            height: ${height};
            .iframeDiv {
                border: none; 
                width: 100%; 
                height: 100%;
            }
        `
    }



    return (
        <StyledWrapper {...wrapperStyles}>
            <iframe className="iframeDiv" src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=${autoplay}&mute=${mute}`}>
            </iframe>
        </StyledWrapper>
    )
}


const widgetModule: WidgetModule = {
    component: DividerEWidget,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.youtubeVideoId,
                displayName: "Youtube Video Id",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.height,
                displayName: "Video height (px, rem)",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.autoplay,
                displayName: "Autoplay",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "True",
                        value: "1",
                    },
                    {
                        displayName: "False",
                        value: "0",
                    },
                ],
                tooltip: "drop down tip",
                isRequired: true,
                defaultValue: "false",
            },
            {
                fieldType: "General",
                name: fields.mute,
                displayName: "Mute",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "True",
                        value: "1",
                    },
                    {
                        displayName: "False",
                        value: "0",
                    },
                ],
                tooltip: "drop down tip",
                isRequired: true,
                defaultValue: "false",
            },
        ],
    },
};

export default widgetModule;